import * as React from 'react';

import dates, {formatIsoDate, getMomentDate} from 'src/utils/date-time';

import {
  WritebackContext,
  UPDATE_QUESTION,
} from 'src/components/writeback/writeback-wrapper';
import {StringListInput} from 'src/components/lib/token-list-input//index';
import Checkbox from 'src/components/lib/checkbox/index';
import DatePicker from 'src/components/lib/date-picker/date-picker';
import BasicDropdown from 'src/components/lib/basic-dropdown/index';
import moduleCss from 'src/components/workflow/event/content/module/editors/module.css';


const dateOptions = [
  {value: 'yyyy-mm-dd', label: 'Year, month, and date'},
  {value: 'mm-dd', label: 'Month and date only'},
];

const alertConditionOptions = [
  {value: 'on_or_before', label: 'on or before'},
  {value: 'on_or_after', label: 'on or after'},
];

export default ({
  conditionalAlerts,
}: {
  conditionalAlerts?: boolean;
}): React.ReactElement<React.ComponentProps<'div'>> => {
  const {state, dispatch} = React.useContext(WritebackContext);
  const currentQuestionType = state.question?.selectedType;
  // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'QuestionType' can't be used to index type 'CurrentQuestion'.
  const currentQuestion = state.question?.[currentQuestionType];

  const updateQuestion = (
    attrs:
      | {
          alertCondition: null;
        }
      | {
          alertCondition: never;
        }
      | {
          alertCondition: string;
        }
      | {
          alertDate: any;
        },
  ) => {
    dispatch({
      type: UPDATE_QUESTION,
      payload: {
        questionType: currentQuestionType,
        // @ts-expect-error - TS2322 - Type '{ alertCondition: null; } | { alertCondition: never; } | { alertCondition: string; } | { alertDate: any; }' is not assignable to type 'Question'.
        attrs,
      },
    });
  };

  return (
    <div className={moduleCss.calendarDate_container}>
      {conditionalAlerts && (
        <div className={moduleCss.calendarDate_alertContainer}>
          <label className={moduleCss.calendarDate_inputLabel}>
            Alert
            <Checkbox
              className={moduleCss.calendarDate_input}
              checked={currentQuestion.alertCondition}
              onChange={(event) => {
                if (currentQuestion.alertCondition) {
                  updateQuestion({alertCondition: null});
                } else {
                  updateQuestion({alertCondition: 'on_or_before'});
                }
              }}
            />
          </label>

          {currentQuestion.alertCondition && (
            <div className={moduleCss.calendarDate_inputContainer}>
              <span className={moduleCss.calendarDate_inputLabel}>
                For responses
              </span>
              <div className={moduleCss.calendarDate_input}>
                <BasicDropdown
                  disabled
                  noOptionText={'None'}
                  options={alertConditionOptions}
                  // @ts-expect-error - TS2322 - Type '{ value: string; label: string; } | undefined' is not assignable to type 'object'.
                  selected={alertConditionOptions.find(
                    (option) => option.value === currentQuestion.alertCondition,
                  )}
                  onChange={(selected) => {
                    // @ts-expect-error - TS2339 - Property 'value' does not exist on type 'object'.
                    updateQuestion({alertCondition: selected.value});
                  }}
                />
              </div>
            </div>
          )}

          {currentQuestion.alertCondition && (
            <div className={moduleCss.calendarDate_inputContainer}>
              <span className={moduleCss.calendarDate_inputLabel}>Date</span>
              <DatePicker
                className={moduleCss.calendarDate_input}
                selected={
                  currentQuestion.alertDate &&
                  getMomentDate(currentQuestion.alertDate)
                }
                onChange={(value) => {
                  if (value) {
                    updateQuestion({alertDate: formatIsoDate(value)});
                  }
                }}
                type="date"
              />
            </div>
          )}
        </div>
      )}
      {conditionalAlerts && (
        <div className={moduleCss.multipleChoiceModule_hintText}>
          {
            'Any alert emails will be sent if the recipient’s response date matches the alert options above.'
          }
        </div>
      )}
    </div>
  );
};
